import { getBulkData } from './getBulkData'
import { getData } from './getData'

export const TypeTicketController = {
  getData,
  getBulkData,
}
